// src/components/Layout.js
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import './Layout.css';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout-root">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="layout-main">
        {/* Top bar (mobile) */}
        <header className="layout-topbar">
          <button className="topbar-menu-btn" onClick={() => setSidebarOpen(true)}>
            ☰
          </button>
          <span className="topbar-title">ಅಕ್ಷರ ದಾಸೋಹ</span>
          <div className="topbar-right">
            <span className="topbar-date">
              {new Date().toLocaleDateString('kn-IN', { day:'numeric', month:'short', year:'numeric' })}
            </span>
          </div>
        </header>
        {/* Page content */}
        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
}
